import React from "react";
import { Link } from "react-router-dom";
import shareImg from "./../../media/icons/share.png";
export default class Comp extends React.PureComponent {
  render = () => (
    <div className={`card_item col-${this.props.col}`}>
      <Link to={`${this.props.url}`}>
        <div className="holder">
          <div className="hovered">
            <button>
              <img alt="" src={shareImg} />
            </button>
          </div>
          <div
            style={{ backgroundImage: `url(${this.props.thumbnail})` }}
            className="img_wrapper"
          />
          <p className="title"> {this.props.title}</p>
        </div>
        {this.props.content
          ? this.props.content.map((item, key) => (
              <p key={key} className="content_item">
                {item.value}
              </p>
            ))
          : ""}
      </Link>
    </div>
  );
}
